import { reactive } from "vue";
import { useCarbucksApi } from "@app/Carbucks";
import { useUser } from "@domain/Security";
import { useConfirm, useNotify } from "@library/Components";
import { useRouter } from "@library/Services";
import { useJupiterProps } from "@modules/Jupiter";
import type { ICarbucksAppTileDto } from "@domain/AppConfiguration/ICarbucksAppTile";
import { reloadMyGarageViewModel } from "@app/MyGarage/Types/MyGarageViewModelStore";
import { setUserHasSwitchedApp } from "./useCheckIfUserHasSwitchedApp";

export const useViewModel = () => reactive( new class
{
    originatorCode: string = '';

    /**
     * Occurs when the user submits the code
     */
    async onSubmitCode()
    {

        const api = useCarbucksApi();
        const result = await api.getAppByOriginatorCodeAsync( this.originatorCode );

        switch ( result.status )
        {
            case 200:
                await this.changeApp( result.data );
                break;
            case 404:
                await useNotify( `<div class="text-lg"><p class="opacity-60">Unfortunately the code you entered is not valid.</p><p class="mt-2">Please try again</p><div>`, "Unknown code" );
                break;
            default:
                await useNotify( 'Unfortunately there was a problem and the code could not be verified.  Please try again later', 'Unable to verify code' );
        }

    }

    /**
     *
     * @param appConfigurationId
     */
    async changeApp( app: ICarbucksAppTileDto )
    {

        // Confirm the switch
        const isConfirmed = await useConfirm( `<p>Change your home dealership to</p><p class="mt-2 font-bold">${app.name}?</p>`, "Confirm Switch" );
        if( isConfirmed == false ) return;

        // Make the switch
        const api = useCarbucksApi();
        const vehicle = useUser().activeVehicle;
        const result = await api.setHomeDealershipApp( vehicle.vehicleId, app.appConfigurationId );

        if( result.success )
        {

            // Reinitialise the user
            const jupiter = useJupiterProps();
            await jupiter.authenticate( true );

            // Reload the MyGarage & Marketplace view models
            await reloadMyGarageViewModel();

            // Set a flag to let the garage page know that we switched
            setUserHasSwitchedApp();

            // Navigate back to MyGarage
            const router = useRouter();
            router.go( '/my-garage' );
            return;

        }

        await useNotify( `<div class="text-lg"><p class="opacity-60">Unfortunately there was a problem connecting you with the dealership.</p><p class="mt-2">Please check the code and try again</p><div>`, "Unable to connect" );

    }

});
